import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import Header from "../header";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { apiCall_domain, token } from "../api";
import axios from "axios";
import UsersCar from "./UsersCar";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import SimpleReactValidator from "simple-react-validator";

class Search extends Component {
  constructor() {
    super();
    this.state = {
      selectedCar: {
        brand: "",
        car: "",
        type: "",
      },
      brands: [],
      loading: false,
      value: 0,
      error: "",
      index: "",
    };
    this.validator = new SimpleReactValidator({
      className: "error",
      messages: {
        required: "این فیلد الزامی است",
      },
      autoForceUpdate: true,
    });
  }

  componentDidMount() {
    localStorage.setItem("data", "");
    localStorage.setItem("dataMyCar", "");
    localStorage.setItem("myCarName", "");
    const headers = {
      Authorization: getApiKey() || token(),
      "content-type": "application/json",
    };

    axios
      .get(`${apiCall_domain}/customer/car-types`, {
        headers,
      })
      .then((res) => {
        this.setState({ brands: res.data.data, loading: false });
      });
  }
  changeCarField = ({ target }) => {
    this.setState({
      selectedCar: { ...this.state.selectedCar, [target.name]: target.value },
    });
  };
  search = () => {
    if (this.validator.allValid()) {
      localStorage.setItem("data", JSON.stringify(this.state.selectedCar));
      this.props.history.push({
        pathname: "/categories/3",
      });
    } else {
      this.validator.showMessages();
    }
  };
  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #F9F9F9;
    }`;

    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={"جستجوی محصولات بر اساس خودرو"}
              backUrl="/mainPage"
            />
            <div className="searchCom">
              <div className="tabs">
                <Tabs>
                  <TabList>
                    <Tab>خودرو های من</Tab>
                    <Tab>جستجو کلی</Tab>
                  </TabList>
                  <TabPanel value={this.state.value} index={1}>
                    <UsersCar props={this.props} />
                  </TabPanel>
                  <TabPanel value={this.state.value} index={0}>
                    <div className="selectControl">
                      <FormControl>
                        <span className="Text">برند ماشین</span>
                        <Select
                          value={this.state.selectedCar.brand}
                          onChange={this.changeCarField}
                          name="brand"
                          displayEmpty
                        >
                          <MenuItem value="">
                            برند ماشین را انتخاب کنید
                          </MenuItem>
                          {this.state.brands.map((item) => (
                            <MenuItem key={item.id} value={item}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    {this.validator.message(
                      "brand",
                      this.state.selectedCar.brand,
                      "required",
                    )}
                    <div className="selectControl">
                      <FormControl>
                        <span className="Text">نام ماشین</span>
                        <Select
                          value={this.state.selectedCar.car}
                          onChange={this.changeCarField}
                          displayEmpty
                          name="car"
                        >
                          <MenuItem value="">ماشین را انتخاب کنید </MenuItem>
                          {this.state.selectedCar.brand?.cars?.map((car) => (
                            <MenuItem
                              key={car.id}
                              value={car}
                              name={String(car.name)}
                              onClick={localStorage.setItem(
                                "myCarName",
                                car.name,
                              )}
                            >{`${car.name ? car.name : ""}`}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    {this.validator.message(
                      "car",
                      this.state.selectedCar.car,
                      "required",
                    )}
                    <div className="selectControl">
                      <FormControl>
                        <span className="Text">تیپ (اختیاری)</span>
                        <Select
                          value={this.state.selectedCar.type}
                          onChange={this.changeCarField}
                          name="type"
                          displayEmpty
                        >
                          <MenuItem value="">تیپ ماشین را انتخاب کنید</MenuItem>
                          {this.state.selectedCar.car?.types?.map((type) => (
                            <MenuItem key={type} value={String(type.id)}>
                              {type.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="error">{this.state.error}</div>
                    <div
                      className="filters_button_wrapper search-filters_button_wrapper"
                      onClick={this.search}
                    >
                      <button className="btn">جستجو</button>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}
export default Search;
